export default __webpack_public_path__ + "static/media/butter-naan.546e57e6.jpg";